export const emptyStateContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  padding: '48px 24px',
};

export const emptyStateIconWrapperStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '60px',
  height: '60px',
  borderRadius: '14px',
  backgroundColor: ({ palette }) => palette.background.disabled,
  color: ({ palette }) => palette.text.placeholder,
  marginBottom: '16px',
};

export const emptyStateTitleStyles = {
  marginBottom: '4px',
};

export const emptyStateBodyStyles = {
  color: ({ palette }) => palette.text.secondary,
  maxWidth: '320px',
  margin: '0 auto',
  marginBottom: '16px',
};
